import { render } from "./BalRadio.vue?vue&type=template&id=2b47c4a7&scoped=true&ts=true"
import script from "./BalRadio.vue?vue&type=script&lang=ts"
export * from "./BalRadio.vue?vue&type=script&lang=ts"

import "./BalRadio.vue?vue&type=style&index=0&id=2b47c4a7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b47c4a7"]])

export default __exports__